module.exports = __webpack_public_path__ + "media/images/email_templates/marketing_thumbnail-788c22aad374f48f52a09be6bdec4b34.png";